module.exports = __webpack_public_path__ + "static/media/w-2_32.23277df9.png";